export {
  ENTITY_STATUS_ACTIVE_INACTIVE_OPTIONS as BOM_STATUS_FILTER_OPTIONS,
  formatEntityStatusLabel as formatBomStatusLabel,
} from '#/modules/commonComponents/table/entityStatus';

export function canActivateBom(status) {
  return status === 'INACTIVE';
}

export function canDeactivateBom(status) {
  return status === 'ACTIVE';
}
